/**
 * Do not edit directly!
 * Changes will be overriden by Style Dictionary.
 */

module.exports = {
  "border": {
    "width": {
      "thin": "1px",
      "medium": "2px",
      "thick": "4px"
    },
    "radius": {
      "small": "0.125rem",
      "medium": "0.25rem",
      "large": "0.5rem",
      "full": "8rem"
    }
  },
  "breakpoints": {
    "s": 321,
    "m": 768,
    "l": 1024,
    "xl": 1280,
    "xxl": 1440
  },
  "color": {
    "brand": {
      "primary": {
        "default": "#002d72",
        "tint": {
          "10": "#1a4280",
          "20": "#33578e",
          "30": "#4d6c9c",
          "40": "#6681aa",
          "50": "#8096b8",
          "60": "#99abc6",
          "70": "#b3c0d4",
          "80": "#ccd5e2",
          "90": "#e6eaf1",
          "95": "#f2f4f7"
        },
        "shade": {
          "10": "#002866",
          "20": "#00245b",
          "30": "#001f4f",
          "40": "#001b44",
          "50": "#001638",
          "60": "#00122d",
          "70": "#000d21",
          "80": "#000916",
          "90": "#00040b"
        }
      },
      "secondary": {
        "default": "#ffed00",
        "tint": {
          "10": "#ffee1a",
          "20": "#fff033",
          "30": "#fff24d",
          "40": "#fff466",
          "50": "#fff680",
          "60": "#fff799",
          "70": "#fff9b3",
          "80": "#fffbcc",
          "90": "#fffde6",
          "95": "#fffef2"
        },
        "shade": {
          "10": "#e5d400",
          "20": "#ccbd00",
          "30": "#b2a500",
          "40": "#998e00",
          "50": "#7f7600",
          "60": "#665e00",
          "70": "#4c4600",
          "80": "#332f00",
          "90": "#00040b"
        }
      }
    },
    "contrast": {
      "black": "#000000",
      "white": "#ffffff"
    },
    "palette": {
      "red": {
        "default": "#de351b",
        "tint": {
          "10": "#e14932",
          "20": "#e45d48",
          "30": "#e7715f",
          "40": "#eb8576",
          "50": "#ee9a8d",
          "60": "#f1aea3",
          "70": "#f5c2bb",
          "80": "#f8d6d1",
          "90": "#fbebe8",
          "95": "#fdf4f3"
        },
        "shade": {
          "10": "#c72f18",
          "20": "#b12a15",
          "30": "#9a2412",
          "40": "#851f10",
          "50": "#6e1a0d",
          "60": "#58150a",
          "70": "#420f08",
          "80": "#2c0a05",
          "90": "#160503"
        }
      },
      "yellow": {
        "default": "#ffed00",
        "tint": {
          "10": "#ffee1a",
          "20": "#fff033",
          "30": "#fff24d",
          "40": "#fff466",
          "50": "#fff680",
          "60": "#fff799",
          "70": "#fff9b3",
          "80": "#fffbcc",
          "90": "#fffde6",
          "95": "#fffef2"
        },
        "shade": {
          "10": "#e5d400",
          "20": "#ccbd00",
          "30": "#b2a500",
          "40": "#998e00",
          "50": "#7f7600",
          "60": "#665e00",
          "70": "#4c4600",
          "80": "#332f00",
          "90": "#191700"
        }
      },
      "green": {
        "default": "#34c082",
        "tint": {
          "10": "#48c68e",
          "20": "#5ccc9b",
          "30": "#71d3a7",
          "40": "#85d9b4",
          "50": "#99dfc0",
          "60": "#ade5cd",
          "70": "#c2ecd9",
          "80": "#d6f2e6",
          "90": "#ebf8f2",
          "95": "#f4fbf8"
        },
        "shade": {
          "10": "#2eac74",
          "20": "#299968",
          "30": "#24865a",
          "40": "#1f734e",
          "50": "#195f40",
          "60": "#144c34",
          "70": "#0f3926",
          "80": "#0a261a",
          "90": "#05120c"
        }
      },
      "blue": {
        "default": "#0059e4",
        "tint": {
          "10": "#1a69e6",
          "20": "#337ae9",
          "30": "#4d8bec",
          "40": "#669bee",
          "50": "#80acf1",
          "60": "#99bcf4",
          "70": "#b3cdf6",
          "80": "#ccddf9",
          "90": "#e6eefc",
          "95": "#f2f6fd"
        },
        "shade": {
          "10": "#004fcc",
          "20": "#0047b6",
          "30": "#003e9f",
          "40": "#003588",
          "50": "#002c71",
          "60": "#00235b",
          "70": "#001a43",
          "80": "#00112d",
          "90": "#000816"
        }
      },
      "grey": {
        "default": "#001432",
        "tint": {
          "10": "#1a2b46",
          "20": "#33435b",
          "30": "#4d5a6f",
          "40": "#667284",
          "50": "#808998",
          "60": "#99a1ad",
          "70": "#b3b8c1",
          "80": "#ccd0d6",
          "90": "#e6e7ea",
          "95": "#f2f3f4"
        },
        "shade": {
          "10": "#00112c",
          "20": "#001028",
          "30": "#000d22",
          "40": "#000c1e",
          "50": "#000918",
          "60": "#000814",
          "70": "#00050e",
          "80": "#00040a",
          "90": "#000104"
        }
      }
    },
    "danger": "#de351b",
    "attention": "#ffed00",
    "success": "#24865a",
    "interaction": "#0059e4",
    "neutral": "#001432",
    "muted": "#33435b",
    "disabled": "#667284",
    "inverted": "#ffffff",
    "invertedMuted": "#ccd0d6",
    "appBackground": "#f2f4f7",
    "focused": "#669bee"
  },
  "font": {
    "weight": {
      "normal": "400",
      "heavy": "900"
    },
    "stack": "Lato, sans-serif",
    "heading": {
      "display": {
        "size": "2rem",
        "line-height": "2.5rem",
        "weight": "900"
      },
      "intro": {
        "size": "4rem",
        "line-height": "5rem",
        "weight": "900"
      },
      "h1": {
        "size": "2rem",
        "line-height": "2.5rem",
        "weight": "400"
      },
      "h2": {
        "size": "1.25rem",
        "line-height": "1.5rem",
        "weight": "900"
      },
      "h3": {
        "size": "1.125rem",
        "line-height": "1.5rem",
        "weight": "900"
      },
      "h4": {
        "size": "1rem",
        "line-height": "1.5rem",
        "weight": "900"
      },
      "h5": {
        "size": "0.8125rem",
        "line-height": "1.25rem",
        "weight": "900"
      },
      "h6": {
        "size": "0.6875rem",
        "line-height": "1rem",
        "weight": "900"
      }
    },
    "text": {
      "small": {
        "size": "0.8125rem",
        "line-height": "1.25rem"
      },
      "medium": {
        "size": "1rem",
        "line-height": "1.5rem"
      },
      "large": {
        "size": "1.125rem",
        "line-height": "1.5rem"
      }
    },
    "label": {
      "size": "0.8125rem",
      "line-height": "1.25rem"
    },
    "input": {
      "size": "1rem",
      "line-height": "1.5rem"
    },
    "title": {
      "size": "0.75rem",
      "line-height": "1rem"
    },
    "button": {
      "small": {
        "size": "0.8125rem",
        "line-height": "1.25rem"
      },
      "medium": {
        "size": "1rem",
        "line-height": "1.5rem"
      },
      "large": {
        "size": "1.125rem",
        "line-height": "1.5rem"
      }
    },
    "bottomNavigation": {
      "size": "0.625rem",
      "line-height": "0.75rem"
    }
  },
  "grid": {
    "margin": "0.75rem",
    "gutter": "0.75rem"
  },
  "logo": {
    "MetroLogo": {
      "small": {
        "height": "1.125rem",
        "width": "6rem"
      },
      "medium": {
        "height": "1.5rem",
        "width": "8.19rem"
      },
      "large": {
        "height": "2.25rem",
        "width": "12.2538rem"
      }
    },
    "MetroLogoCompact": {
      "small": {
        "height": "1.6875rem",
        "width": "2.125rem"
      },
      "medium": {
        "height": "1.6875rem",
        "width": "2.125rem"
      },
      "large": {
        "height": "1.6875rem",
        "width": "2.125rem"
      }
    },
    "MetroLogoTr": {
      "small": {
        "height": "1.75rem",
        "width": "6rem"
      },
      "medium": {
        "height": "2.38rem",
        "width": "8.19rem"
      },
      "large": {
        "height": "3.3rem",
        "width": "11.75rem"
      }
    },
    "MetroLogoTrInverted": {
      "small": {
        "height": "1.75rem",
        "width": "6rem"
      },
      "medium": {
        "height": "2.38rem",
        "width": "8.19rem"
      },
      "large": {
        "height": "3.3rem",
        "width": "11.75rem"
      }
    },
    "MakroLogo": {
      "small": {
        "height": "1.5rem",
        "width": "6rem"
      },
      "medium": {
        "height": "2rem",
        "width": "8rem"
      },
      "large": {
        "height": "2rem",
        "width": "8rem"
      }
    },
    "MakroLogoCompact": {
      "small": {
        "height": "1.625rem",
        "width": "2.125rem"
      },
      "medium": {
        "height": "1.625rem",
        "width": "2.125rem"
      },
      "large": {
        "height": "1.625rem",
        "width": "2.125rem"
      }
    },
    "MetroLogoCorporate": {
      "small": {
        "height": "1.125rem",
        "width": "6rem"
      },
      "medium": {
        "height": "1.5rem",
        "width": "8.19rem"
      },
      "large": {
        "height": "2.25rem",
        "width": "12.2538rem"
      }
    },
    "MetroLogoCorporateInverted": {
      "small": {
        "height": "1.125rem",
        "width": "6rem"
      },
      "medium": {
        "height": "1.5rem",
        "width": "8.19rem"
      },
      "large": {
        "height": "2.25rem",
        "width": "12.2538rem"
      }
    },
    "MetroLogoCorporateCompact": {
      "small": {
        "height": "2rem",
        "width": "2.125rem"
      },
      "medium": {
        "height": "2rem",
        "width": "2.125rem"
      },
      "large": {
        "height": "2rem",
        "width": "2.125rem"
      }
    },
    "MetroLogoCorporateInvertedCompact": {
      "small": {
        "height": "2rem",
        "width": "2.125rem"
      },
      "medium": {
        "height": "2rem",
        "width": "2.125rem"
      },
      "large": {
        "height": "2rem",
        "width": "2.125rem"
      }
    },
    "MetroLogoCn": {
      "small": {
        "height": "2.0625rem",
        "width": "3.942rem"
      },
      "medium": {
        "height": "2.75rem",
        "width": "5.237rem"
      },
      "large": {
        "height": "2.25rem",
        "width": "11.09rem"
      }
    },
    "MetroLogoCnInverted": {
      "small": {
        "height": "2.0625rem",
        "width": "3.942rem"
      },
      "medium": {
        "height": "2.75rem",
        "width": "5.237rem"
      },
      "large": {
        "height": "2.25rem",
        "width": "11.09rem"
      }
    }
  },
  "shadow": {
    "color": "#001432",
    "alpha": 0.2,
    "small": {
      "default": "0 1px 3px 0",
      "hover": "0 2px 6px 0",
      "inner": "0 1px 3px 0"
    },
    "medium": {
      "default": "0 1px 4px 0",
      "hover": "0 2px 8px 0",
      "inner": "0 4px 8px 0"
    },
    "large": {
      "default": "0 1px 8px 0",
      "hover": "0 2px 16px 0"
    },
    "xx-large": {
      "default": "0 8px 32px 0"
    },
    "inverted": {
      "default": "0 -2px 6px 0"
    }
  },
  "spacing": {
    "none": "0",
    "xxx-small": "0.125rem",
    "xx-small": "0.25rem",
    "x-small": "0.5rem",
    "small": "0.75rem",
    "medium": "1rem",
    "large": "1.5rem",
    "x-large": "2rem",
    "xx-large": "3rem"
  }
};